import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    pmNo: {
        name: () => '知识域代码',
    },

    pmName: {
        name: () => '知识域名称',
        required: () => true,
    },
})
